//namespace
window.QJTApp = window.QJTApp || { modules: {} };

QJTApp.modules.home             = QJTApp.modules.home || {};
QJTApp.modules.home.models      = QJTApp.modules.home.models || {};
QJTApp.modules.home.views       = QJTApp.modules.home.views || {};
QJTApp.modules.home.collections = QJTApp.modules.home.collections || {};
QJTApp.modules.home.routes      = QJTApp.modules.home.routes || {};

/**
 * Módulo de montagem da Home do site
 *
 * @module IndexPage
 * @namespace modules.home
 */
QJTApp.modules.home.IndexPage = (function() {
  'use strict';

  /**
   * Sinaliza a primeira vez que os elementos do grid (masonry) são carregados.
   *
   * @private
   * @property isMasonryFirstTimeLoading
   * @type Boolean
   * @default true
   */
  var isMasonryFirstTimeLoading = true;

  /**
   * Sinaliza se acabaram os itens.
   *
   * @private
   * @property isItemsFinished
   * @type Boolean
   * @default false
   */
  var isItemsFinished = false;

  /**
   * O elemento html que irá conter todos os itens do grid.
   *
   * @private
   * @property container
   * @type JQuery
   * @default $('#posts-wrapper')
   */
  var container = $('#posts-wrapper');

  /**
   * A referência para selecionar o elemento que contém cada item do grid.
   *
   * @private
   * @property item
   * @type String
   * @default '.post-item'
   */
  var item = '.post-item';

  /**
   * A largura padrão em pixels do elemento que contém cada item do grid.
   *
   * @private
   * @property colWidth
   * @type Number
   * @default 310
   */
  var colWidth = 311;

  /**
   * O número de itens já carregados.
   *
   * @private
   * @property itemsLoaded
   * @type Number
   * @default 0
   */
  var itemsLoaded = 0;

  /**
   * O número de itens a serem carregados a cada requisição.
   *
   * @private
   * @property itemsToLoad
   * @type Number
   * @default 0
   */
  var itemsToLoad = 0;

  var eventAggregator = _.extend({}, Backbone.Events);

  /**
   * A view do grid.
   *
   * @private
   * @property mainRouter
   * @type QJTApp.modules.home.routes.Router
   */
  var mainRouter = new QJTApp.modules.home.routes.Router();

  /**
   * A coleção que vai armazenar todos os itens do grid.
   *
   * @private
   * @property allItems
   * @type QJTApp.modules.home.collections.ItemsCollection
   */
  var allItems = new QJTApp.modules.home.collections.ItemsCollection();

  /**
   * A view do grid.
   *
   * @private
   * @property allItemsView
   * @type QJTApp.modules.home.views.AllItemsView
   */
  var allItemsView = new QJTApp.modules.home.views.AllItemsView({collection: allItems});

  /**
   * Armazena os ids dos itens do slider principal separados por vírgula.
   *
   * @private
   * @property sliderIds
   * @type String
   * @default ''
   */
   var sliderIds = '';

  //instancia o grid com o plugin Masonry passando o objeto de opções
  container.masonry({
    columnWidth: colWidth,
    itemSelector: item,
    transitionDuration: 0,
    gutter: 18
  });

  //configura o container como o elemento html da view (allItemsView)
  allItemsView.setElement(container);

  //insere o elemento html da view (allItemsView) ao final do container
  container.append(allItemsView.render().el);

  //carrega as fontes com o Google webfontLoader
  WebFont.load({
    google: {families: ['Open+Sans:300italic,400italic,600italic,700italic,400,600,700,300:latin,latin-ext']},
    loading: function() {
      console.log('WebFont - Loading...');
    },
    active: function() {
      console.log('WebFont - active!');
      //assim que as fontes estão carregadas chama loadItems
      loadItems();
    },
    inactive: function() {
      console.log('WebFont - inactive!');
    }
  });

  $('.flexslider').flexslider({
    animation: "slide",
    slideshow: true,
    controlNav: false,
    slideshowSpeed: 8000
  });

  /**
   * Faz a requisição inicial ao servidor, recebe o json e chama assembleItems.
   *
   * @private
   * @method loadItems
   */
  function loadItems() {
    console.log('loadItems...');

    var animationEvent = whichAnimationEvent();
    $('#main-loader').one(animationEvent, function(e) {
      // Do something when the transition ends
      
      sliderIds = $('#postsslider').data('slider-posts-ids');

      //requisição via post
      var request = $.ajax({
        url: 'home/getPosts?page=0&sliderIds=' + sliderIds,
        type: 'GET'
      }).done(function( data, textStatus, jqXHR ) {
        console.log('done - data: ', data);
        assembleItems(data);
      }).fail(function( jqXHR, textStatus, errorThrown ) {
        console.log('loadItems Error!');
        console.log(jqXHR);
        console.log(textStatus);
        console.log(errorThrown);
      });
    });
    
    $('#main-loader').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(e) {
      console.log('loadItems() -> Chamou old!');
    });

    $('#main-loader').addClass('fadeIn');
  }

  /*
  * Identifica o evento de transição impedindo que ele seja disparado
  * duas vezes. inspirado em: http://davidwalsh.name/css-animation-callback
  *
  * @private
  * @method whichAnimationEvent
  * @return {String} Event name.
  *
  */
  function whichAnimationEvent(){
    var t,
        el = document.createElement("fakeelement");

    var animations = {
      "animation"      : "animationend",
      "OAnimation"     : "oAnimationEnd",
      "MozAnimation"   : "animationend",
      "WebkitAnimation": "webkitAnimationEnd"
    }

    for (t in animations){
      if (el.style[t] !== undefined){
        return animations[t];
      }
    }
  }

  /**
   * Recebe os dados carregados do servidor e monta os itens no grid.
   *
   * @private
   * @method assembleItems
   * @param {Object} data Um Objeto JSON contendo os itens.
   */
  function assembleItems(data) {
    console.log('assembleItems...');
    //mostra os banners
    showBanners();

    showSlider();

    var arrModelItems = [];
    var arrElements = [];
    itemsToLoad = data.items.length;

    //itera sobre o parametro json recebido 
    for (var i = 0; i < itemsToLoad; i++) {

      //cria o item e insere ele no array de models
      arrModelItems[i] = new QJTApp.modules.home.models.SingleItem(data.items[i]);
      
      //insera o item criado na coleção
      allItems.push(arrModelItems[i]);

      //insere no array de elementos html o respectivo elemento de cada item
      arrElements[i] = allItemsView.children.findByModel(arrModelItems[i]).$el;
    }

    //faz um casting do array de elementos convertendo ele em um objeto jQuery
    var elements = $(arrElements);

    //itera sobre cada elemento do objeto jQuery criado
    elements.each(function( index ) {
      $(this).imagesLoaded()
      .always(onAllImagesProcessed)
      .done(onAllImagesSucessLoaded)
      .fail(onAllImagesSomeFail)
      .progress(onItemsProgress);
    });
  }

  /**
   * ...
   *
   * @private
   * @method onItemsProgress
   * @param {Object} imgLoadInstance ...
   * @param {Object} image ...
   */
  function onItemsProgress(imgLoadInstance, image) {
    
  }

  /**
   * ...
   *
   * @private
   * @method onAllImagesProcessed
   * @param {Object} imgLoadInstance ...
   */
  function onAllImagesProcessed(imgLoadInstance) {
    
  }

  /**
   * Callback chamada quando todas as imagens de um item foram carregadas com
   * sucesso, sem nenhuma quebra.
   *
   * @private
   * @method onAllImagesSucessLoaded
   * @param {Object} imgLoadInstance A instância do item cujas imagens foram
   * carregadas.
   */
  function onAllImagesSucessLoaded(imgLoadInstance) {

    //referencia o item carregado
    var item = $(imgLoadInstance.elements[0]);

    //adiciona ele ao grid
    container.data('masonry').appended(item);


    var timeoutID = window.setTimeout(function(){
      item.addClass('appear');
    }, 300);


    increaseItemsLoaded();
  }

  /**
   * Callback chamada quando todas as imagens de um item foram processadas mas pelo
   * menos uma está quebrada, ou seja, falhou no carregamento.
   *
   * @private
   * @method onAllImagesSomeFail
   * @param {Object} imgLoadInstance A instância do item cujas imagens foram
   * processadas.
   */
  function onAllImagesSomeFail(imgLoadInstance) {

    //referencia o item processado
    var item = $(imgLoadInstance.elements[0]);

    //encontra qual é a view do item que teve a falha no carregamento.
    var view = allItemsView.children.findByCid(item.data('cid'));

    //reconfigura a model para que a view se atualize escondendo a falha.
    view.model.set({'images': undefined, imagesLength: 0}, {silent:true});
    view.model.updateType();

    //adiciona o item ao grid
    container.data('masonry').appended(item);


    var timeoutID = window.setTimeout(function(){
      item.addClass('appear');
    }, 300);


    increaseItemsLoaded();
  }

  /**
   * ...
   *
   * @private
   * @method increaseItemsLoaded
   */
  function increaseItemsLoaded() {
    itemsLoaded ++;
    console.log('itemsToLoad:' + itemsToLoad + ' - itemsLoaded:' + itemsLoaded );
    if(itemsLoaded === itemsToLoad) {
      console.log('COMPLETED!');

      $('#main-loader').addClass('fadeOut').removeClass('fadeIn');

      if(isMasonryFirstTimeLoading){
        isMasonryFirstTimeLoading = false;
        initInfiniteScroll(); 
      }
    }
  }

  /**
   * ...
   *
   * @private
   * @method showBanners
   */
  function showBanners() {
    //acha os banners, se houverem 
    var slimBanner = container.find('#home-slimbanner');
    slimBanner.css('display', 'block').addClass('fadeIn');

    //insere os banners no layout do masonry
    container.data('masonry').stamp(slimBanner);
    container.data('masonry').layout();
  }

  /**
   * ...
   *
   * @private
   * @method showSlider
   */
  function showSlider() {
    var slider = container.find('.main-slider');

    //insere o slider no layout do masonry
    container.data('masonry').stamp(slider);
    container.data('masonry').layout();
  }

  /**
   * ...
   *
   * @private
   * @method initInfiniteScroll
   */
  function initInfiniteScroll() {

    console.log('initInfiniteScroll...');

    container.infinitescroll({
      navSelector: '#content-nav',    // selector for the paged navigation 
      nextSelector: '#content-nav a',  // selector for the NEXT link (to page 2)
      debug: false,
      dataType: 'json',
      appendCallback: false,
      itemSelector: item,    // selector for all items you'll retrieve
      /*Loading: {
        finishedMsg: 'Todos os posts já carregados',
        img: null
      },*/
      path: function (pageNumber) {

        console.log('pageNumbersss: ' + pageNumber);
        console.log('isItemsFinished: ' + isItemsFinished);

        if(!isItemsFinished) {
          //para o sistema a página inicial é a página 0
          var page = pageNumber - 1;

          console.log('path - pageNumber: ' + page);

          $('#main-loader').addClass('fadeIn').removeClass('fadeOut');

          return 'home/getPosts?page=' + page + '&sliderIds=' + sliderIds;
        }
      },
    },
    // trigger Masonry as a callback
    function (json, opts) {

      $('#main-loader').addClass('fadeOut').removeClass('fadeIn');

      console.log('json: ');
      console.log(json);

      if(json === null) {
        isItemsFinished = true;
        $('.the-end').css('display', 'block');
      } else {
        var page = opts.state.currPage -1;
        //console.log('Home (anonymous callback) - page: ' + page);
          
        assembleItems(json);
      }
    });

    console.log('end initInfiniteScroll');
  }

  return {
    //loadItems: loadItems
  }

})();
